// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createPackage,
  deletePackage,
  getDetailPackage,
  getListItemOptionalPackage,
  getListPackage,
  updatePackage,
} from './packageThunk';

export interface IPackageState {
  isRefreshPackageList: boolean;
  isRefreshPackageItemOptionList: boolean;
}

export const initialState: IPackageState = {
  isRefreshPackageList: false,
  isRefreshPackageItemOptionList: false,
};

const packageSlice = createSlice({
  name: 'package',
  initialState,
  reducers: {
    setRefreshPackageList(state, action) {
      state.isRefreshPackageList = action.payload;
    },

    setRefreshPackageListItemOption(state, action) {
      state.isRefreshPackageItemOptionList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list package
    builder
      .addCase(getListPackage.pending, (_state) => {
      })
      .addCase(getListPackage.fulfilled, (_state) => {
      })
      .addCase(getListPackage.rejected, (_state) => {
      });

    // GET: Get detail package
    builder
      .addCase(getDetailPackage.pending, (_state) => {
      })
      .addCase(getDetailPackage.fulfilled, (_state) => {
      })
      .addCase(getDetailPackage.rejected, (_state) => {
      });

    // POST: Create package
    builder
      .addCase(createPackage.pending, (_state) => {
      })
      .addCase(createPackage.fulfilled, (_state) => {
      })
      .addCase(createPackage.rejected, (_state) => {
      });

    // DELETE: Delete package
    builder
      .addCase(deletePackage.pending, (_state) => {
      })
      .addCase(deletePackage.fulfilled, (_state) => {
      })
      .addCase(deletePackage.rejected, (_state) => {
      });

    // PUT: Update package
    builder
      .addCase(updatePackage.pending, (_state) => {
      })
      .addCase(updatePackage.fulfilled, (_state) => {
      })
      .addCase(updatePackage.rejected, (_state) => {
      });

    // GET: Get list item optional package
    builder
      .addCase(getListItemOptionalPackage.pending, (_state) => {
      })
      .addCase(getListItemOptionalPackage.fulfilled, (_state) => {
      })
      .addCase(getListItemOptionalPackage.rejected, (_state) => {
      });
  },
});

// Action
export const packageActions = packageSlice.actions;

// Selectors
export const selectIsRefreshListPackage = (state: RootState) => state.package.isRefreshPackageList;
export const selectIsRefreshListPackageItemOption = (state: RootState) => state.package.isRefreshPackageItemOptionList;

// Reducer
const packageReducer = packageSlice.reducer;
export default packageReducer;
